<template>
    <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        @after-leave="$emit('close')"
    >
        <div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
            <div
                v-if="open"
                class="fixed inset-0 w-full h-screen flex items-center justify-center bg-semi-75 bg-opacity-75 transition-opacity backdrop-filter backdrop-blur-sm"
                @click.self="close"
                aria-hidden="true"
            >
                <div
                    class="bg-white dark:bg-gray-900 rounded-lg text-left overflow-y-scroll max-h-[50vw] shadow-xl sm:my-8 sm:w-full left-1/2 top-1/2"
                    :class="width"
                    role="dialog" aria-modal="true"
                >
                    <div class="bg-white dark:bg-gray-800 px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                        <div class="sm:flex sm:items-start">
                            <div :class="getIconColor"
                                 class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full sm:mx-0 sm:h-10 sm:w-10"
                                 v-if="icon"
                            >
                                <icon :name="icon" class="h-6 w-6" viewBox="0 0 24 24"/>
                            </div>
                            <div class="text-center sm:text-left w-full"
                                 :class="{'mt-3 sm:ml-4 sm:mt-0': icon}"
                            >
                                <h3 class="text-lg leading-6 font-medium text-gray-900 dark:text-white"
                                    v-if="title"
                                >
                                    {{ title }}
                                </h3>
                                <div class="dark:text-white" :class="[{'mt-2': title}, bodyClasses]">
                                    <slot name="body"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-gray-50 dark:bg-gray-700 px-4 py-3 sm:px-6 sm:flex sm:justify-end sm:space-x-1">
                        <default-button @click.native="close" v-if="!hideCloseButton && isClosable"
                                        color="white"
                        >
                            {{ $t('general.cancel') }}
                        </default-button>
                        <slot name="footer"/>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'element-modal',

    props: {
        icon: {
            type: String,
        },
        iconColor: {
            type: String,
            default: 'gray',
        },
        title: {
            type: String,
        },
        hideCloseButton: {
            type: Boolean,
            default: false,
        },
        isClosable: {
            type: Boolean,
            default: true,
        },
        backdropBlur: {
            type: Boolean,
            default: true,
        },
        open: {
            type: Boolean,
            default: false,
        },
        width: {
            type: String,
            default: 'w-full md:w-3/4 lg:w-1/2 xl:w-1/4',
        },
        bodyClasses: {
            type: Array | Object | String,
            required: false,
        },
    },

    methods: {
        close() {
            this.$emit('close');
        },
    },

    computed: {
        getIconColor() {
            switch (this.iconColor) {
                case 'gray':
                    return 'bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-gray-200';
                case 'red':
                    return 'bg-red-100 text-red-600 dark:bg-red-600 dark:text-red-200';
                case 'green':
                    return 'bg-green-100 text-green-600 dark:bg-green-600 dark:text-green-200';
                case 'cyan':
                    return 'bg-cyan-100 text-cyan-600 dark:bg-cyan-600 dark:text-cyan-200';
                case 'orange':
                    return 'bg-orange-100 text-orange-600 dark:bg-orange-600 dark:text-orange-200';
                case 'pink':
                    return 'bg-pink-100 text-pink-600 dark:bg-pink-600 dark:text-pink-200';
                case 'rose':
                    return 'bg-rose-100 text-rose-600 dark:bg-rose-600 dark:text-rose-200';
                case 'blue':
                    return 'bg-blue-100 text-blue-600 dark:bg-blue-600 dark:text-blue-200';
                case 'indigo':
                    return 'bg-indigo-100 text-indigo-600 dark:bg-indigo-600 dark:text-indigo-200';
                case 'purple':
                    return 'bg-purple-100 text-purple-600 dark:bg-purple-600 dark:text-purple-200';
                case 'yellow':
                    return 'bg-yellow-100 text-yellow-600 dark:bg-yellow-600 dark:text-yellow-200';
                case 'lime':
                    return 'bg-lime-100 text-lime-600 dark:bg-lime-600 dark:text-lime-200';
                case 'emerald':
                    return 'bg-emerald-100 text-emerald-600 dark:bg-emerald-600 dark:text-emerald-200';
                case 'teal':
                    return 'bg-teal-100 text-teal-600 dark:bg-teal-600 dark:text-teal-200';
                case 'white':
                    return 'bg-white-100 text-white-600';
                default:
                    return 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-200';
            }
        },
    },
};
</script>
